import { Avatar, Button } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { DownloadIconMobile, UploadFilesPurpleIcon } from 'Images';
import { forwardRef } from 'react';
interface IUploadFileButton {
  clickHandler: () => void;
  children?: string;
  ariaLabel?: string;
  dataId?: string;
}
export const UploadFileButton = forwardRef<
  HTMLButtonElement,
  IUploadFileButton
>((props, ref) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Requests);
  const isDesktop = useIsDesktop();
  const dataId = props.dataId ? props.dataId : '';
  const ariaLabel = props.ariaLabel || `${dictionary.upload}`;
  return (
    <Button
      data-id={dataId}
      ref={ref}
      sx={
        isDesktop
          ? {
              minWidth: '130px',
              width: '100%',
              fontSize: '20px',
              fontWeight: '600',
              color: '#344266',
              backgroundColor: 'primary.shade_100',
              borderRadius: '8px',
              padding: '4px 20px',
              '&:hover': { backgroundColor: 'primary.shade_200' },
            }
          : {
              width: '100%',
              fontSize: '16px',
              color: '#344266',
              backgroundColor: '#fff',

              borderRadius: '8px',
              padding: '6px 16px',
              border: '1px solid #B7CCFF',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mt: '12px',
              '&:hover': { backgroundColor: 'primary.shade_200' },
            }
      }
      onClick={props.clickHandler}
      aria-label={ariaLabel}
      endIcon={
        <Avatar
          alt=''
          src={isDesktop ? UploadFilesPurpleIcon : DownloadIconMobile}
          sx={
            isDesktop
              ? { width: '24px', height: '24px' }
              : {
                  width: '32px',
                  height: '32px',
                }
          }
        />
      }
      tabIndex={props.dataId ? undefined : -1}
    >
      {props.children}
    </Button>
  );
});
